import { QueryKeys } from '@shared/domain/queryKeys'
import { useApiClient } from '@shared/hooks/useApiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { Category } from '../domain/Bet.domain'

interface CreateCategoryInput {
  name: string
  color?: string
}

export const useCreateCategory = () => {
  const api = useApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: CreateCategoryInput) => {
      const response = await api.post<Category>('/categories', data)
      return response.data
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QueryKeys.Categories] })
    },
  })
}
